var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleAddIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 6.1998C12.9 5.70275 12.497 5.2998 12 5.2998C11.5029 5.2998 11.1 5.70275 11.1 6.1998V11.5998H5.69999C5.20293 11.5998 4.79999 12.0027 4.79999 12.4998C4.79999 12.9969 5.20293 13.3998 5.69999 13.3998L11.1 13.3998V18.7998C11.1 19.2969 11.5029 19.6998 12 19.6998C12.497 19.6998 12.9 19.2969 12.9 18.7998V13.3998H18.3C18.797 13.3998 19.2 12.9969 19.2 12.4998C19.2 12.0027 18.797 11.5998 18.3 11.5998H12.9V6.1998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleAddIcon);
export default __webpack_public_path__ + "static/media/role-add-icon.3d07ab3ae41a46b0b01acf94bfb8b665.svg";
export { ForwardRef as ReactComponent };